import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
//import { Auth, authState } from '@angular/fire/auth';
import { map, take, Observable } from 'rxjs';

import { UserAuthenticationService } from '../firestore/user-authentication.service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate{

  private router = inject(Router);
  
  /*
  // Independent of user authentication service
  private auth = inject(Auth);  
  canActivate(): Observable<boolean> {
    return authState(this.auth).pipe(
      map(user => {
        if (user) {
          return true;
        } else {
          this.router.navigate(['/login']);
          return false;
        }
      })
    );
  }
  */

  // Dependes of user authentication service
  private userAuthenticationService = inject(UserAuthenticationService)
  canActivate(): Observable<boolean> {
    return this.userAuthenticationService.getUserIsLoggedValue().pipe(
      take(1), // Tomar el valor actual y completar
      map(isAuthenticated => {
        if (isAuthenticated) {
          return true;
        } else {
          this.router.navigate(['/login']);
          return false;
        }
      })
    );
  }
  


  

}
